import { DRAWABLE_TOOL_IDS, PLACEABLE_TOOL_IDS, SEGMENT_TOOL_IDS } from './constants';
import {
  DrawableToolId,
  PlaceableToolId,
  ToolbarItem,
  ToolbarMenuItem,
  ToolbarToolItem,
  ToolId,
} from './types';

export const isTool = (item: ToolbarItem): item is ToolbarToolItem => item.type === 'tool';
export const isMenu = (item: ToolbarItem): item is ToolbarMenuItem => item.type === 'menu';

/**
 * @description Type guard to check if a ToolId is a DrawableToolId, which means it's a tool that can be drawn on the canvas (e.g. walls, areas, etc.)
 */
export function isDrawableToolId(id: ToolId): id is DrawableToolId {
  return (DRAWABLE_TOOL_IDS as readonly string[]).includes(id);
}

/**
 * @description Type guard to check if a ToolId is a PlaceableToolId, usually used for things like templates
 */
export function isPlaceableToolId(id: ToolId): id is PlaceableToolId {
  return (PLACEABLE_TOOL_IDS as readonly string[]).includes(id);
}

/**
 * @description Type guard to check if a ToolId is a SegmentToolId, which means it's a tool that corresponds to a segment (e.g. highway_angled)
 */
export function isSegmentToolId(id: ToolId): id is (typeof SEGMENT_TOOL_IDS)[number] {
  return (SEGMENT_TOOL_IDS as readonly string[]).includes(id);
}
